import { useState } from "react";
import ROLE_COLORS from "../../../constants/roleColors";
import RoleBadge from "../../../components/Profile/RoleBadge/RoleBadge";
import AdminBlock from "./AdminBlock";
import strings from "../../../locales/ro.json";
import "./RolesManager.css";

const CreateRoleForm = ({ roleTypes, onSubmit, loading }) => {
  const [name, setName] = useState("");
  const [roleTypeId, setRoleTypeId] = useState("");
  const [selectedColor, setSelectedColor] = useState(ROLE_COLORS[0].hex);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !roleTypeId) return;
    try {
      await onSubmit({ name: name.trim(), role_type_id: Number(roleTypeId), color: selectedColor });
      setName("");
      setRoleTypeId("");
      setSelectedColor(ROLE_COLORS[0].hex);
    } catch (_) {
      // error handled in hook
    }
  };

  return (
    <AdminBlock title={strings.admin.roles.createForm.title} defaultOpen={false}>
      <form className="rm-create-form-content" onSubmit={handleSubmit}>
        <div className="rm-form-row">
          <div className="rm-field">
            <label>{strings.admin.roles.createForm.nameLabel}</label>
            <input
              type="text"
              placeholder={strings.admin.roles.createForm.namePlaceholder}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="rm-field">
            <label>{strings.admin.roles.createForm.typeLabel}</label>
            <select value={roleTypeId} onChange={(e) => setRoleTypeId(e.target.value)}>
              <option value="">{strings.admin.roles.createForm.typePlaceholder}</option>
              {roleTypes.map((rt) => (
                <option key={rt.id} value={rt.id}>
                  {rt.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="rm-field">
          <label>{strings.admin.roles.createForm.colorLabel}</label>
          <div className="rm-color-picker">
            {ROLE_COLORS.map((c) => (
              <button
                key={c.hex}
                type="button"
                className={`rm-color-swatch ${selectedColor === c.hex ? "selected" : ""}`}
                style={{ backgroundColor: c.hex }}
                title={c.name}
                onClick={() => setSelectedColor(c.hex)}
              />
            ))}
          </div>
        </div>

        {name && (
          <div className="rm-preview">
            <span className="rm-preview-label">{strings.admin.roles.createForm.previewLabel}</span>
            <RoleBadge name={name || strings.admin.roles.createForm.newRoleFallback} color={selectedColor} />
          </div>
        )}

        <button type="submit" className="rm-submit-btn" disabled={!name.trim() || !roleTypeId || loading}>
          {loading ? strings.admin.roles.createForm.submitLoading : strings.admin.roles.createForm.submit}
        </button>
      </form>
    </AdminBlock>
  );
};

export default CreateRoleForm;
